export const PageSAP = {
    ACCOUNT_PAYMENT_AMOUNT: "ACCOUNT_PAYMENT_AMOUNT",
    AICI_FONCTIONNEMENT: "AICI_FONCTIONNEMENT",
    AICI_INSCRIPTION: "AICI_INSCRIPTION",
    AICI_TRANSMISSION: "AICI_TRANSMISSION",
    AICI_VALIDATION: "AICI_VALIDATION",
    AREA_CHOICE: "AREA_CHOICE",
    BYPASS_LOGIN: "BYPASS_LOGIN",
    CLIENT_CHOICE: "CLIENT_CHOICE",
    COMMANDE_ATTRIBUTION: "COMMANDE_ATTRIBUTION",
    COMMANDE_CHOIX_DISPOSITIF: "COMMANDE_CHOIX_DISPOSITIF",
    COMMANDE_CONFIRMATION: "COMMANDE_CONFIRMATION",
    COMMANDE_INFORMATIONS_COMPLEMENTAIRES: "COMMANDE_INFORMATIONS_COMPLEMENTAIRES",
    COMMANDE_INFORMATIONS_PAIEMENT: "COMMANDE_INFORMATIONS_PAIEMENT",
    COMMANDE_PRESTATION: "COMMANDE_PRESTATION",
    COMMANDE_RESILIER_RECURRENCE: "COMMANDE_RESILIER_RECURRENCE",
    COMMANDE_SUIVI: "COMMANDE_SUIVI",
    VISUALISATION_MODIFICATION_DEMANDE: "VISUALISATION_MODIFICATION_DEMANDE",
    COMMANDE: "COMMANDE",
    CONTACT_DEMANDE_INFORMATION: "CONTACT_DEMANDE_INFORMATION",
    CONTACT_DEMANDE_RAPPEL: "CONTACT_DEMANDE_RAPPEL",
    CONTACT_INFORMATIONS: "CONTACT_INFORMATIONS",
    CONTACT: "CONTACT",
    CREATION_DEMANDE_CHOIX_DISPOSITIF: "CREATION_DEMANDE_CHOIX_DISPOSITIF",
    CREATION_DEMANDE_CHOIX_PRESTATION: "CREATION_DEMANDE_CHOIX_PRESTATION",
    CREATION_DEMANDE_CONFIRMATION: "CREATION_DEMANDE_CONFIRMATION",
    CREATION_DEMANDE_DETAILS_PRESTATION: "CREATION_DEMANDE_DETAILS_PRESTATION",
    CREATION_DEMANDE_INFORMATIONS_COMPLEMENTAIRES: "CREATION_DEMANDE_INFORMATIONS_COMPLEMENTAIRES",
    CREATION_DEMANDE_INFORMATIONS_PAIEMENT: "CREATION_DEMANDE_INFORMATIONS_PAIEMENT",
    CREATION_DEMANDE_NOS_PRESTATIONS: "CREATION_DEMANDE_NOS_PRESTATIONS",
    CREATION_DEMANDE_QUESTIONS_ATTRIBUTION: "CREATION_DEMANDE_QUESTIONS_ATTRIBUTION",
    DECLARATION_ACCESSIBILITE: "DECLARATION_ACCESSIBILITE",
    DEMANDE_CREATION: "DEMANDE_CREATION",
    DEMANDE_SUIVI: "DEMANDE_SUIVI",
    DEMANDE: "DEMANDES",
    DOCUMENTS: "DOCUMENTS",
    FACTURES: "FACTURES",
    FAQ: "FAQ",
    FORGOTTEN_LOGIN: "FORGOTTEN_LOGIN",
    FORGOTTEN_PASSWORD: "FORGOTTEN_PASSWORD",
    HOME: "HOME",
    LEGAL_NOTICE: "LEGAL_NOTICE",
    LOGIN: "LOGIN",
    MY_PROFILE_AICI_INFORMATIONS: "MY_PROFILE_AICI_INFORMATIONS",
    MY_PROFILE_BANK_INFORMATIONS: "MY_PROFILE_BANK_INFORMATIONS",
    MY_PROFILE_COMPLEMENTARY_INFORMATIONS: "MY_PROFILE_COMPLEMENTARY_INFORMATIONS",
    MY_PROFILE_CONNECTION_INFORMATIONS: "MY_PROFILE_CONNECTION_INFORMATIONS",
    MY_PROFILE_ENVELOPE: "MY_PROFILE_ENVELOPE",
    MY_PROFILE_MAIN_INFORMATIONS: "MY_PROFILE_MAIN_INFORMATIONS",
    MY_PROFILE_RELATIVES_ADD_OR_EDIT: "MY_PROFILE_RELATIVES_ADD_OR_EDIT",
    MY_PROFILE_RELATIVES: "MY_PROFILE_RELATIVES",
    NOT_FOUND: "NOT_FOUND",
    PAIEMENT_FACTURES: "PAIEMENT_FACTURES",
    PROFILE_AICI_INFORMATIONS: "PROFILE_AICI_INFORMATIONS",
    PROFILE_BANK_INFORMATIONS: "PROFILE_BANK_INFORMATIONS",
    PROFILE_COMPLEMENTARY_INFORMATIONS: "PROFILE_COMPLEMENTARY_INFORMATIONS",
    PROFILE_CONNECTION_INFORMATIONS: "PROFILE_CONNECTION_INFORMATIONS",
    PROFILE_MAIN_INFORMATIONS: "PROFILE_MAIN_INFORMATIONS",
    PROFILE: "PROFILE",
    REGISTRATION_BENEFICIAIRE_PROFILE: "REGISTRATION_BENEFICIAIRE_PROFILE",
    REGISTRATION_PASSWORD: "REGISTRATION_PASSWORD",
    REGISTRATION_PROCHE_PROFILE: "REGISTRATION_PROCHE_PROFILE",
    RESET_PASSWORD: "RESET_PASSWORD",
    STYLE_GUIDE: "STYLE_GUIDE",
    TECHNICAL_ERROR: "TECHNICAL_ERROR",
    UNAUTHORIZED: "UNAUTHORIZED",
}

export const PageCESU = {
    ACCOUNT_PAYMENT_AMOUNT_OVERVIEW: "ACCOUNT_PAYMENT_AMOUNT_OVERVIEW",
    ACCOUNT_PAYMENT_AMOUNT: "ACCOUNT_PAYMENT_AMOUNT",
    ACCOUNT_PAYMENT_CESU_DECLARATION: "ACCOUNT_PAYMENT_CESU_DECLARATION",
    ACCOUNT_PAYMENT_CESU_IDENTIFICATION: "ACCOUNT_PAYMENT_CESU_IDENTIFICATION",
    ACCOUNT_PAYMENT_CHOICE: "ACCOUNT_PAYMENT_CHOICE",
    ACCOUNT_PAYMENT_CONFIRMATION: "ACCOUNT_PAYMENT_CONFIRMATION",
    ACCOUNT_PAYMENT_ORGANIZATION: "ACCOUNT_PAYMENT_ORGANIZATION",
    ACCOUNT_PAYMENT_PAJE_DECLARATION: "ACCOUNT_PAYMENT_PAJE_DECLARATION",
    ACCOUNT_PAYMENT_PAJE_IDENTIFICATION: "ACCOUNT_PAYMENT_PAJE_IDENTIFICATION",
    AMOUNT_STATEMENT: "AMOUNT_STATEMENT",
    BYPASS_LOGIN: "BYPASS_LOGIN",
    CERTIFICAT_AIDANT: "CERTIFICAT_AIDANT",
    CESU_CONVERSION_AMOUNT: "CESU_CONVERSION_AMOUNT",
    CESU_CONVERSION_CHOICE: "CESU_CONVERSION_CHOICE",
    CESU_CONVERSION_CONFIRMATION: "CESU_CONVERSION_CONFIRMATION",
    CESU_CONVERSION_DELIVERY: "CESU_CONVERSION_DELIVERY",
    CHECK_PAYMENT_AMOUNT: "CHECK_PAYMENT_AMOUNT",
    CHECK_PAYMENT_CHOICE: "CHECK_PAYMENT_CHOICE",
    CHECK_PAYMENT_CONFIRMATION: "CHECK_PAYMENT_CONFIRMATION",
    DECLARATION_ACCESSIBILITE: "DECLARATION_ACCESSIBILITE",
    DECLARATION_HISTORY: "DECLARATION_HISTORY",
    EDIT_ORDER_PROFILE: "EDIT_ORDER_PROFILE",
    HELP: "HELP",
    HOME: "HOME",
    INTERVENANT_DIRECT_SEARCH: "INTERVENANT_DIRECT_SEARCH",
    INTERVENANT_SEARCH: "INTERVENANT_SEARCH",
    LEGAL_NOTICE: "LEGAL_NOTICE",
    LOGIN: "LOGIN",
    MFA: "MFA",
    MILLESIME_TRADE_CHOICE: "MILLESIME_TRADE_CHOICE",
    MILLESIME_TRADE_CONFIRMATION: "MILLESIME_TRADE_CONFIRMATION",
    MILLESIME_TRADE_DELIVERY: "MILLESIME_TRADE_DELIVERY",
    MILLESIME_TRADE_PAYMENT: "MILLESIME_TRADE_PAYMENT",
    NOT_FOUND: "NOT_FOUND",
    ORDER_CONFIRMATION: "ORDER_CONFIRMATION",
    ORDER_CONTENT: "ORDER_CONTENT",
    ORDER_DELIVERY: "ORDER_DELIVERY",
    ORDER_HISTORY: "ORDER_HISTORY",
    ORDER_INFORMATION: "ORDER_INFORMATION",
    ORDER_PAYMENT: "ORDER_PAYMENT",
    ORDER_PROFILE: "ORDER_PROFILE",
    ORDER_SESSION_LIST: "ORDER_SESSION_LIST",
    PAYMENT_CHOICE: "PAYMENT_CHOICE",
    PAYMENT_HISTORY: "PAYMENT_HISTORY",
    RECOVER_LOGIN: "RECOVER_LOGIN",
    RECOVER_LOGIN_PASSWORD: "RECOVER_LOGIN_PASSWORD",
    REGISTRATION_CONFIRMATION: "REGISTRATION_CONFIRMATION",
    REGISTRATION_CONTROL: "REGISTRATION_CONTROL",
    REGISTRATION_PASSWORD: "REGISTRATION_PASSWORD",
    REGISTRATION_PROFILE: "REGISTRATION_PROFILE",
    REGISTRATION_SESSION_CHOICE: "REGISTRATION_SESSION_CHOICE",
    REGISTRATION: "REGISTRATION",
    RESET_PASSWORD: "RESET_PASSWORD",
    STYLE_GUIDE: "STYLE_GUIDE",
    TAX_DOCUMENT: "TAX_DOCUMENT",
    TECHNICAL_ERROR: "TECHNICAL_ERROR",
    TRANSACTIONS_HISTORY: "TRANSACTIONS_HISTORY",
    UNAUTHORIZED: "UNAUTHORIZED",
    USER_PROFILE_AICI_INFORMATIONS: "USER_PROFILE_AICI_INFORMATIONS",
    USER_PROFILE_AUTHENTICATION_INFORMATIONS: "USER_PROFILE_AUTHENTICATION_INFORMATIONS",
    USER_PROFILE_BANK_INFORMATIONS: "USER_PROFILE_BANK_INFORMATIONS",
    USER_PROFILE_DECLARATION_INFORMATIONS: "USER_PROFILE_DECLARATION_INFORMATIONS",
    USER_PROFILE_MAIN_INFORMATIONS: "USER_PROFILE_MAIN_INFORMATIONS",
    USER_PROFILE_PRODUCT_CHOICE: "USER_PROFILE_PRODUCT_CHOICE",
    VIEW_ORDER: "VIEW_ORDER",
    VISUALISATION_CHOICE: "VISUALISATION_CHOICE",
}
